import React from 'react';
import {useIntl} from 'react-intl';

import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {TranslationKeys} from 'utils/constants/routeConstants';
import NotFoundInfo from 'components/not-found-info';
import './styles.scss';

export const AccessDenied: React.FunctionComponent = () => {
  const intl = useIntl();

  useGetTranslations({
    translationKey: TranslationKeys.Error
  });

  return <div className={'access-denied'}>
    <NotFoundInfo
      title={intl.formatMessage({
        id: 'gritx.error.accessDenied',
        defaultMessage: 'You are denied access to this site, please contact the administrator.'
      })}/>
  </div>;
};
